<template>
    <KCard
        as="figure"
        :variant="variant"
        :padding="padding"
        :class="classes"
    >
        <blockquote
            v-if="$slots.default || text"
            :class="element('text')"
        >
            <slot>{{ text }}</slot>
        </blockquote>

        <figcaption
            v-if="$slots.author || author"
            :class="element('attribution')"
        >
            <slot name="author">
                {{ author }}
            </slot>
        </figcaption>
    </KCard>
</template>

<script setup lang="ts">
import type { KQuoteProps } from './types'
import useBem from '@yeeroen/use-bem'

import { computed } from 'vue'
import KCard from '../card/k-card.vue'

defineOptions({ name: 'KQuote' })

const props = withDefaults(defineProps<KQuoteProps>(), {
    variant: 'plain',
    padding: 'none',
    size: 'md',
})

defineSlots<{
    default?: () => unknown
    author?: () => unknown
}>()

const { block, element, modifier } = useBem('k-quote')

const classes = computed(() => block(
    modifier(props.size),
))
</script>

<style lang="scss">
@use './k-quote.scss';
</style>
